import { SIMSwapOTPVerificationAction } from '../actions/SIMSwapOTPVerificationAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "SIMSwapOTPVerification",
        steps: [
            {
                sequence: "0",
                stepId: "SIMSwapOTPVerification",
                offerContainerId: "",
                fields: [
                    {
                        name: "OTPStatus",
                        value: ""
                    }
                ]
            }
        ]
    },
    initiateOTPResponse: {

    },
    validateOTPResponse: {

    },
    rSendOTPResponse: {

    },
  }
  
  const SIMSwapOTPVerificationReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var OTPVerificationValue = { ...state.requestBody.steps };
  
    switch (type) {
      case SIMSwapOTPVerificationAction.OTP_VERIFICATION_VALUE:
        OTPVerificationValue[0].fields[0].value = payload.otp;
        OTPVerificationValue[0].offerContainerId = payload.offerContainerId;
        return state;

        case SIMSwapOTPVerificationAction.SIMSWAP_OTP_INITIATE_SUCCESS:
            return { ...state, initiateOTPResponse: payload };

        case SIMSwapOTPVerificationAction.SIMSWAP_OTP_VALIDATE_SUCCESS:
            return { ...state, validateOTPResponse: payload };

        case SIMSwapOTPVerificationAction.SIMSWAP_OTP_RSEND_SUCCESS:
            return { ...state, rSendOTPResponse: payload };
  
      case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
        let section = payload.sections.filter((section: any) => {
          return (section.sectionId === 'SIMSwapOTPVerification')
        });
        if (section.length > 0) {
          let numberTypeValue = section[0].steps[0].fields[0];
          OTPVerificationValue[0].offerContainerId = section[0].steps[0].offerContainerId;
          OTPVerificationValue[0].fields[0].value = numberTypeValue ? numberTypeValue.value : "";
        }
        return state;
  
      default:
        return state;
    }
  }
  
  export default SIMSwapOTPVerificationReducer;